<template>
  <div class="cloudStorageGcpSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="6">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('RAM.common.PleaseSelectCompany')"
            :transfer="true"
            @on-change="changeCompanyID"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyIdList"
              :key="item.id"
              >{{ item.companyName }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="6">
        <Input
          v-model="accountName"
          :placeholder="$t('RAM.common.filterByAccountName')"
        />
      </Col>
      <Col span="6">
        <Input
          v-model="resourceName"
          :placeholder="$t('resourceLifecycle.queryByResourceName')"
        />
      </Col>
      <Col span="4">
        <Button
                    type="primary"
                    v-hasPermission="['resourceConfigurationManagement:gcp:cloudStorageGcp:page']"
                    @click="getData"
                    >{{ $t("message.select") }}</Button>
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../utils/cookieUtil";
import TableCloudStorageGcp from "../cloudStorage/TableCloudStorageGcp";
var tableCloudStorageGcp = TableCloudStorageGcp;
export default {
  name: "CloudStorageGcpSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyIdList: [],
      accountName: "",
      resourceName: "",
    };
  },
  mounted: function () {
    if (this.company == 1) {
      this.listRegisterInformation();
    } else {
      // tableCloudStorageGcp.methods.showAll();
    }
  },
  methods: {
    getData(){
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountName", this.accountName);
      eventBus.$emit("resourceName", this.resourceName);
      tableCloudStorageGcp.methods.showAll();
    },
    //查询公司
    listRegisterInformation: function () {
      this.$api.user.listRegisterInformation().then((res) => {
        // 获取公司列表数据
        this.companyIdList = res.data.companies;
        if (this.companyIdList) {
          this.companyId = this.companyIdList[0].id;
        }
        this.searchCompany();
      });
    },
    // 切换公司
    changeCompanyID: function () {
      this.searchCompany();
    },
    // 按公司搜索
    searchCompany: function () {
      eventBus.$emit("companyId", this.companyId);
      // tableCloudStorageGcp.methods.showAll();
    },
    // 按账户名称查询
    searchAccountName: function () {
      eventBus.$emit("accountName", this.accountName);
      // tableCloudStorageGcp.methods.showAll();
    },

    // 按账户名称查询
    searchResourceName: function () {
      eventBus.$emit("resourceName", this.resourceName);
      // tableCloudStorageGcp.methods.showAll();
    },
  },
};
</script>
<style scoped>
.cloudStorageGcpSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/gcp/cloudStorage/CloudStorageGcpSearch.vue